import { type Common } from '../common.js';
import { type TransformationValidationResult } from '../models/resourceGateway/transformation.js';

export interface ValidateTransformationOptions {
  transformationDefinition: unknown;
}

export class API {
  common: Common;
  baseEndpoint = '/resource-gateway/integration-gateway/transformations';

  constructor(common: Common) {
    this.common = common;
  }

  async validate(options: ValidateTransformationOptions): Promise<TransformationValidationResult> {
    const url = this.common.constructPath(`${this.baseEndpoint}/validate`);
    return await this.common.postJSON(url, options);
  }
}
